import * as React from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';

import { useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';

import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import IconButton from '@mui/material/IconButton';

import useredit from "../../assets/icon/useredit.gif";
import resercalendar from "../../assets/icon/resercalendar.gif";
import medicalhistory from "../../assets/icon/medicalhistory.gif";
import microphone from "../../assets/icon/microphone.gif";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import * as util from "../../utils/util";
import { goOrLogin } from "../../utils/loginRedirect";
import { useEffect } from "react";
import api from "../../utils/api";
import Skeleton from '@mui/material/Skeleton';



const MoreInfo = () => {
  const navigate = useNavigate();
  /*
   * 이름 초기값은 로그인할 때 저장해 둔 localStorage.userName 을 쓴다 (Login.tsx).
   * 예전에는 무조건 '비회원'으로 시작해서, 로그인한 사용자도 getProfile 응답이
   * 올 때까지 '비회원 님'을 봤다. 이 화면은 하단 탭으로 드나들 때마다 다시
   * 마운트되므로 그 깜빡임이 매번 반복됐고, 모바일 회선에서는 더 길게 보였다.
   * 조회가 실패해도(타임아웃·오프라인) 저장된 이름이 그대로 남는다.
   */
  const [memberName, setMemberName] = React.useState(
    () => util.strNull(window.localStorage.userName) || '비회원',
  );

  useEffect(() => {
    if (util.strNull(window.localStorage.userCusID) !== '') {
      api.get('permission/getProfile').then((res: any) => {
        // 빈 값으로 덮어쓰면 저장된 이름까지 지워진다 — 값이 있을 때만 갱신한다
        const name = util.strNull(res?.data?.name);
        if (name !== '') setMemberName(name);
      }).catch(function (error: any) {
        console.log(error)
      });
    }
  }, []);


  return (

    <Grid sx={{ p: 0, width: '100%', mt: 2 }}>
      <Card sx={{ m: '20px auto', bgcolor: '#fff', p: '10px', borderRadius: 5, boxSizing: 'border-box' }}>
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} sx={{ mb: 1, p:1 }} >
          <AccountCircleRoundedIcon sx={{ color: '#bbb', fontSize: 30, }} />
          <Typography component="span" sx={{ fontSize: 20, color: '#030070', m: 0, mb: 0, fontWeight: 700 }}>
            {memberName}
          </Typography>
          <Typography component="span" sx={{ color: '#777', m: 0, mb: 0, fontWeight: 700 }}>
            님
          </Typography>
        </Stack>

        <Divider variant="middle" />

        <Stack direction="row" justifyContent={'center'}
          sx={{
            m: 1, mt:2,
            '& .MuiStack-root': { flex: 1, alignItems: 'center' },
            '& .MuiTypography-root': { fontSize: 14, fontWeight:700, color: '#333', textAlign: 'center', mt: 1 },
            '& .subText': { fontSize: 14, fontWeight: 400, textAlign: 'center', m: 0 },
          }}>

          <Button sx={{ flex: 1, p:0 }} onClick={() => {
            goOrLogin(navigate, '/MyPage/MyPage')
          }}>
            <Stack direction="column" justifyContent="center">
              <Avatar alt="" src={useredit} sx={{}} />
              <Typography component="div" sx={{}}>
                내 정보
              </Typography>
            </Stack>
          </Button>


          <Button sx={{ flex: 1, p:0 }} onClick={() => {
            goOrLogin(navigate, '/MyPage/ReservationView')
          }}>
            <Stack direction="column" justifyContent="center">
              <Avatar alt="" src={resercalendar} sx={{}} />
              <Typography component="div" >
                예약확인
              </Typography>
            </Stack>
          </Button>

          <Button sx={{ flex: 1, p:0 }} onClick={() => {
            goOrLogin(navigate, '/MyPage/HealthResult')
          }}>
            <Stack direction="column" justifyContent="center">
              <Avatar alt="" src={medicalhistory} sx={{}} />
              <Typography component="div">
                검진결과
              </Typography>
            </Stack>
          </Button>

          <Button sx={{ flex: 1, p:0 }} onClick={() => {
            goOrLogin(navigate, '/Notice/Notice')
          }}>
            <Stack direction="column" justifyContent="center">
              <Avatar alt="" src={microphone} sx={{}} />
              <Typography component="div">
                공지사항
              </Typography>
            </Stack>
          </Button>



        </Stack>
      </Card>

    </Grid>
  );
}


export default MoreInfo;